<template>
  <b-container class="page-container">
    <bread-crumbs currentpage="Log in" />
    <h1>Log in</h1>
    <p>
      Voor dat je artikelen kunt reserveren is het vereist je ingelogd bent.
    </p>

    <b-row>
      <b-col sm="12" class="mb-3">
        <b-alert v-if="error" show variant="danger">
          {{ error }}
        </b-alert>
      </b-col>
      <b-col sm="12" lg="6" xl="6">
        <b-card>
          <b-form @submit.prevent="loginFormSubmit">
            <b-form-group
              id="input-group-1"
              label="E-mailadres"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.username"
                type="text"
                placeholder="E-mailadres"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-2"
              label="Wachtwoord"
              label-for="input-2"
            >
              <b-input-group class="mt-3">
                <b-form-input
                  v-model="form.password"
                  placeholder="Wachtwoord"
                  required
                  :type="showPassword ? 'text' : 'password'"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    title="Wachtwoord tonen"
                    variant="primary"
                    @click="showPasswordToggle()"
                    ><font-awesome-icon v-if="!showPassword" fas icon="eye"/>
                    <font-awesome-icon v-if="showPassword" fas icon="eye-slash"
                  /></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-row>
              <b-col xs="12" sm="6">
                <b-button class="mb-2" type="submit" variant="primary"
                  >Inloggen
                  <font-awesome-icon
                    v-if="processing"
                    class="fa-spin"
                    far
                    :icon="['fad', 'spinner']"
                /></b-button>
              </b-col>
              <b-col xs="12" sm="6">
                <router-link
                  class="float-right"
                  :to="{ name: 'forgotPassword' }"
                  >Wachtwoord vergeten?</router-link
                >
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
      <b-col sm="12" md="6" class="pt-4 pt-lg-0">
        <h4>Nog geen logingegevens?</h4>
        <p>
          Enkel voor West-Vlaamse non profit organisaties.<br />
          Niet voor bedrijven of particulier gebruik, zie
          <a href="https://www.west-vlaanderen.be/uitleendienst-reglement"
            >reglement</a
          >.
        </p>
        <router-link class="btn btn-primary mt-3" to="register"
          >Registreren</router-link
        >
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { login } from '@/services/AuthorizationService'


export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      processing: false,
      error: false,
      showPassword: false
    }
  },
  metaInfo: {
    title: `Inloggen`
  },
  created: function() {
    if (this.$route.params.registered) {
      this.$toasted.show('Account aanvraag succesvol')
    }
  },
  methods: {
    notify({ message }) {
      this.$bvToast.toast(message, {
        autoHideDelay: 5000,
        appendToast: false,
        title: 'success!',
        toaster: 'b-toaster-bottom-right'
      })
    },
    async loginFormSubmit() {
      this.processing = true

      const result = await login({
        username: this.form.username,
        password: this.form.password
      })

      if (this.$store.getters.cartCache?.CartItems?.Collection?.length === 0) {
        this.$store.commit('rentalInformation/reset')
      }

      this.$store.dispatch('customer/fetchCustomer')

      if (result) {
        this.error = result
      }

      this.processing = false
    },
    showPasswordToggle: function() {
      if (this.showPassword) {
        this.showPassword = false
      } else {
        this.showPassword = true
      }
    }
  }
}
</script>
<style scoped></style>
